import { useContext, useEffect, useState } from 'react';
import { DataContext } from 'providers/data';

import { Box, Typography } from '@mui/material';

import NavSolicitation from './NavSolicitation';
import FadeAnimation from 'components/views/FadeAnimation';

import CircularProgress from '@mui/material/CircularProgress';
import { ReactComponent as IcTestEquipment } from 'assets/icons/ic-test-equipment.svg';
import { ReactComponent as IcSuccessRequest } from 'assets/icons/ic-success-request.svg';
import { ReactComponent as IcCertificateOperation } from 'assets/icons/ic-certificate-operation.svg';

const CertificateOperation = () => {
    const [isLoading, setIsLoading] = useState(false);
    const { selectedCar, dataEquipmentTest, handleGetEquipmentTest } = useContext(DataContext);

    const handlePostEquipmentTestState = () => {
        if (selectedCar) {
            setIsLoading(true);
            handleGetEquipmentTest(selectedCar.NR_PLATAFORMA);
        }
    }

    useEffect(() => {
        if (dataEquipmentTest !== undefined) {
            setIsLoading(false);
        }
    }, [dataEquipmentTest]);

    return (
        <FadeAnimation>
            <Box>
                <NavSolicitation title='Certificado de funcionamento' icon={<IcCertificateOperation />} />
                {isLoading ?
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginTop: { xs: '6rem', md: '10rem' }
                    }}>
                        <CircularProgress />
                        <Typography fontSize='.9375rem' paddingTop='1rem' fontWeight={700}>
                            Aguarde enviando a solicitação...
                        </Typography>
                    </Box>
                    :
                    dataEquipmentTest ?
                        <>
                            <Box sx={{
                                textAlign: 'center',
                                maxWidth: '18rem',
                                margin: '0 auto',
                                position: 'relative',
                                height: '8.5rem'
                            }}>
                                <IcSuccessRequest />
                                <Box sx={{ position: 'absolute', bottom: '0', width: '100%' }}>
                                    <Typography sx={{
                                        fontSize: '1.25rem',
                                        fontWeight: 700,
                                        borderRadius: '8px',
                                        textAlign: 'center',
                                        border: '1px solid #97C93D',
                                        padding: '.5rem .3rem .3rem',
                                        backgroundColor: 'white',
                                        marginBottom: '.2rem',
                                    }}>
                                        {dataEquipmentTest}
                                    </Typography>

                                    <Typography fontSize='.75rem'>
                                        Númedo do protocolo
                                    </Typography>
                                </Box>
                            </Box>
                            <Box sx={{ paddingTop: '1.2rem', maxWidth: '36.3rem', margin: '0 auto' }}>
                                <Typography fontSize='.9375rem' lineHeight='1.4'>
                                    Em <b>até 72 horas</b>, você receberá um e-mail com a confirmação de que seu rastreador
                                    está funcionando normalmente.
                                </Typography>
                                <Typography fontSize='.9375rem' lineHeight='1.4' padding='1.43rem 0 1.27rem'>
                                    Caso o equipamento não esteja em pleno funcionamento, você será orientado com os
                                    procedimentos para o agendamento de manutenção ou até mesmo a troca
                                    do equipamento.
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <Typography sx={{
                                    fontSize: '1.25rem',
                                    padding: '.6rem 1.875rem .3rem',
                                    backgroundColor: 'primary.light',
                                    color: 'white',
                                    fontWeight: 700
                                }}>
                                    ATENÇÃO
                                </Typography>
                                <Typography sx={{
                                    fontSize: '.9375rem',
                                    padding: { xs: '.6rem .75rem .4rem', md: '.6rem 1.375rem .4rem' },
                                    lineHeight: '18px',
                                    textAlign: 'center',
                                    border: '1px solid #0AA8E3'
                                }}>
                                    Para que a verificação da situação do rastreador seja concluída com <br />
                                    sucesso, <strong>o veículo deve ser movimentado durante o período de teste.</strong>
                                </Typography>
                            </Box>
                        </>
                        :
                        <>
                            <Typography fontSize='.9375rem' paddingBottom='1rem' lineHeight='22px'>
                                Para garantir a eficácia do rastreador, <strong>realizamos testes períodicos</strong> do<br />
                                funcionamento do produto, caso seja encontrado alguma anomalia nossos <br />
                                técnicos entrarão em contato, <strong>não se preocupe!</strong>
                            </Typography>
                            <Typography fontSize='.9375rem' lineHeight='22px'>
                                O teste de Certificado de Funcionamento é opcional, caso queira realizar <br />
                                clique no ícone abaixo:
                            </Typography>

                            <Box sx={{ paddingTop: '1rem', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <Box sx={{ cursor: 'pointer' }} onClick={() => handlePostEquipmentTestState()}>
                                    <IcTestEquipment />
                                </Box>
                                <Box sx={{ paddingTop: '1.25rem', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <Typography sx={{
                                        fontSize: '1.25rem',
                                        padding: '.6rem 1.875rem .3rem',
                                        backgroundColor: 'primary.light',
                                        color: 'white',
                                        fontWeight: 700
                                    }}>
                                        ATENÇÃO
                                    </Typography>
                                    <Typography sx={{
                                        fontSize: '.9375rem',
                                        padding: { xs: '.6rem .75rem .4rem', md: '.6rem 1.375rem .4rem' },
                                        lineHeight: '18px',
                                        textAlign: 'center',
                                        border: '1px solid #0AA8E3'
                                    }}>
                                        Para que a verificação da situação do rastreador seja concluída com <br />
                                        sucesso, <strong>o veículo deve ser movimentado durante o período de teste.</strong>
                                    </Typography>
                                </Box>
                            </Box>
                        </>
                }
            </Box>
        </FadeAnimation>
    );
}

export default CertificateOperation;

